// extracted by mini-css-extract-plugin
module.exports = {"openMapBtn":"styles_openMapBtn__2d3sA"};